// migrated 1:1 from @nexato/nx-core-module, #712 (was never migrated during the framework merge, #669)
import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';

@Component({
  selector: 'nx-edit-chips-input',
  template: `
    <div>
      <label for="chips">{{label | translate}}<ng-container *ngIf=isRequired()>*</ng-container></label>
      <p-chips
        [ngModel]="chips"
        (ngModelChange)="onModelChange($event)"
        (onBlur)="onBlur()"
        [placeholder]="placeholder | translate"
        id="chips"
        [disabled]="isDisabled"
        [ngClass]="{'invalid': ngControl?.invalid && ngControl?.touched}"
      ></p-chips>
      <small *ngIf="helpText">{{helpText | translate}}</small>
    </div>
  `,
  styles: [`

  `],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditChipsInputComponent),
      multi: true
    }
  ]
})
export class EditChipsInputComponent implements ControlValueAccessor, OnInit {

  ngControl: NgControl;
  isDisabled: boolean;
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() helpText: string;

  chips: string[];

  private onChange: (value: string[]) => void;
  private onTouched: () => void;

  constructor(private _injector: Injector) {
  }

  ngOnInit() {
    this.ngControl = this._injector.get(NgControl);
    this.ngControl.valueAccessor = this;
  }

  writeValue(chips: string[]): void {
    this.chips = chips;
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onModelChange(chips: string[]): void {
    this.chips = chips;
    if (this.onChange) {
      this.onChange(this.chips);
    }
  }

  onBlur(): void {
    if (this.onTouched) {
      this.onTouched();
    }
  }

  isRequired(): boolean {
    return this.ngControl?.control?.hasValidator(Validators.required);
  }

}
